import RightArrowSvg from "../../Atoms/RightArrowSvg/RightArrowSvg";
import "./SolutionsPattern.scss";
import { Link } from "wouter";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";

function SolutionsPattern({ icon, title, content, linkRoute }) {
	const {language} = useLanguageCtx();

	return (
		<div className="solutionsPattern-container">
			<div className="solutionsPattern-icon-container flex center-content-items ">
				<img src={icon} alt="icon-img" className="soutionsPattern-icon" />
			</div>
			<div className="solutionsPattern-content-container">
				<p className="t4 no-space">{title}</p>
				<p className="body-18 mt-10 mb-10">{content}</p>
				<Link href={linkRoute ? linkRoute : ""}>
					<div className="solutionsPattern--link-container">
						<p className="body-14 c-light-blue solutionsPattern--link-text">
							{language === "spanish" ? "CONOCE MÁS" : "LEARN MORE"}
						</p>
						<div className="solutionsPattern--svg-container">
							<RightArrowSvg />
						</div>
					</div>
				</Link>
			</div>
		</div>
	);
}

export default SolutionsPattern;
